import { Outlet } from 'react-router-dom'

const Driver = () => {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default Driver